import { Component, Input, OnInit } from '@angular/core';
import { QuickTips } from '@generated/graphql';

@Component({
    selector: 'app-knowledge-quick-tips',
    standalone: true,
    imports: [],
    templateUrl: './knowledge-quick-tips.component.html',
    styles: ``,
})
export class KnowledgeQuickTipsComponent implements OnInit {
    @Input() entry: QuickTips;

    quickTips: QuickTips | null = null;

    constructor() {}

    ngOnInit(): void {
        this.quickTips = this.entry;
    }
}
